import {Purpose} from "./purpose";
import {IPurpose as IGVLPurposeInfo} from "./vendor-list";
import cmp from "../context/context";

class LIPurpose extends Purpose {

    public static override build(purposeId:number) : LIPurpose|null {
        const gvlPurpose: IGVLPurposeInfo|undefined = cmp().vendorList?.getPurposeInfo(purposeId);
        if (gvlPurpose) {
            return new LIPurpose(gvlPurpose);
        }
        return null;
    }

    public override get accepted() :  boolean|undefined {
        return cmp().tcString?.purposesLI[this.id];
    }

}

export {LIPurpose}
